// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("../../reason/common/Env.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let PropertyPageNavbar_property_graphql = require("../../__generated__/PropertyPageNavbar_property_graphql.bs.js");

function PropertyPage__Navbar$Navbar$Link(props) {
  return JsxRuntime.jsx("a", {
    children: props.text,
    className: "text-gray-700 font-medium",
    href: props.to_
  });
}

let Link = {
  make: PropertyPage__Navbar$Navbar$Link
};

function PropertyPage__Navbar$Navbar(props) {
  let propertyId = props.propertyId;
  let shouldShowPropertyDetails = props.shouldShowPropertyDetails;
  let tanStaff = Stdlib_Option.getOr(Stdlib_Option.map(UserSession.useAgentInfoOpt(), v => v.tanStaff), false);
  let isImpersonated = AuthSession.useIsImpersonated();
  let __x = props.hasFiles && shouldShowPropertyDetails;
  let __x$1 = props.propertyType === "ForSale";
  let match = isImpersonated || tanStaff;
  return JsxRuntime.jsxs("nav", {
    children: [
      JsxRuntime.jsxs("ul", {
        children: [
          ReactRender.ifTrue(JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
              text: "Files",
              to_: "#files"
            }),
            className: "p-4 first:pl-0"
          }), __x),
          ReactRender.ifTrue(JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
              text: "Showings",
              to_: "#showings"
            }),
            className: "p-4 first:pl-0"
          }), __x$1),
          ReactRender.ifTrue(JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
              text: "Location",
              to_: "#location"
            }),
            className: "p-4 first:pl-0"
          }), shouldShowPropertyDetails),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
              text: "Activity",
              to_: "#activity"
            }),
            className: "p-4 first:pl-0"
          }),
          JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(PropertyPage__Navbar$Navbar$Link, {
              text: "Conversations",
              to_: "#conversations"
            }),
            className: "p-4 first:pl-0"
          })
        ],
        className: "flex overflow-scroll sm:[scrollbar-width:none]"
      }),
      propertyId !== undefined && match ? JsxRuntime.jsx("a", {
          children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            size: "small",
            children: "Open in Admin App"
          }),
          className: "hover:no-underline",
          href: Env.adminAppUrl + `/properties/` + propertyId,
          rel: "noreferrer noopener",
          target: "_blank"
        }) : null
    ],
    className: TailwindMerge.twMerge([
      props.hasImages ? "" : "border-b mb-8",
      "flex justify-between items-center"
    ])
  });
}

let Navbar = {
  Link: Link,
  make: PropertyPage__Navbar$Navbar
};

let convertFragment = PropertyPageNavbar_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageNavbar_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageNavbar_property_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__Navbar(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyPageNavbar_property_graphql.node, convertFragment, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  let totalImages = Stdlib_Option.getOr(Stdlib_Option.map(property.imageCount, c => c.totalCount), 0);
  let totalFiles = Stdlib_Option.getOr(Stdlib_Option.map(property.fileCount, c => c.totalCount), 0);
  let match = property.__typename;
  let propertyType = match === "ForSalePropertyV5" ? "ForSale" : "Rental";
  return JsxRuntime.jsx(PropertyPage__Navbar$Navbar, {
    hasImages: totalImages > 0,
    hasFiles: totalFiles > 0,
    propertyType: propertyType,
    shouldShowPropertyDetails: shouldShowPropertyDetails,
    propertyId: property.id
  });
}

let make = PropertyPage__Navbar;

exports.Navbar = Navbar;
exports.Fragment = Fragment;
exports.make = make;
/* Env Not a pure module */
